import "./index.scss";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../config/baseApi";

const ModalAddPackagePhoto = ({
  closeModal,
  setStep,
  setSelectedImage,
  selectedImage,
  imageUrl,
  setImageUrl,
  editMode,
  productsValues,
}: any) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) setSelectedImage(file);
  };

  useEffect(() => {
    if (selectedImage) {
      setImageUrl(URL.createObjectURL(selectedImage));
    }
  }, [selectedImage]);

  const renderImage = () => {
    if (selectedImage) return imageUrl;
    if (editMode && productsValues?._id)
      return `${api}/package/photo/${productsValues._id}`;
    return null;
  };

  return (
    <div className="package-photo-modal">
      <header className="modal-header">
        <h2>{editMode ? "Edit Package Image" : "Add Package Image"}</h2>
        <button className="close-btn" onClick={closeModal}>
          <i className="bx bx-x" />
        </button>
      </header>

      <main className="modal-body">
        <div className="image-card">
          {renderImage() ? (
            <>
              <img src={renderImage()!} alt="Package" />

              <div className="image-actions">
                <label className="icon-btn">
                  <i className="bx bx-repost" />
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={handleFileChange}
                  />
                </label>

                <button
                  className="icon-btn danger"
                  onClick={() => setSelectedImage(null)}
                >
                  <i className="bx bx-trash" />
                </button>
              </div>
            </>
          ) : (
            <label className="upload-placeholder">
              <i className="bx bx-image-add" />
              <span>Upload image</span>
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleFileChange}
              />
            </label>
          )}
        </div>
      </main>

      <footer className="modal-footer">
        <div className="stepper">
          <span />
          <span className="active" />
          <span />
        </div>

        <div className="actions">
          <button className="btn-outline" onClick={() => setStep("first")}>
            Back
          </button>
          <button className="btn-primary" onClick={() => setStep("third")}>
            Next
          </button>
        </div>
      </footer>
    </div>
  );
};

export default ModalAddPackagePhoto;
